import * as React from "react";
const SvgVectorRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 15.61 4.41 17l5.01-5-5.01-5L3 8.39 6.56 12zM21 6H8v2h13zm0 7v-2H11v2zm0 5v-2H8v2z" }));
export default SvgVectorRight;
